import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cinput() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

  return (
    <div>
      
      <Sides/>
       <Helmet>
 
 <title>input Statement in c++ programming language tutorial For Beginners</title>
 <meta name="description" content="input in c++ programming language tutorial for beginners.input in c++ programming language at run time scanf ( ) function is commonly used to input the value,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,input in c++ programming language tutorial for beginners,programming language,String input in cpp,tutorial for begineers,c++ input,input in c++ programming language at run time,input in cpp,learn c++ programming language,learn code online,c++ input integer,cpp input and output,c++ input from keyboard,cpp user input integer,c++ input output,c++ input string,cpp input in c++ programming code" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-input" />
 </Helmet>

 <div className='lg:pl-56'>


      <h1 className="m-4 mh1">Input Statement in C++ 
</h1>
<div className="first">
        <a href="/cpp-first-program"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-literal"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
      <h2 className="mt-4 mh2">Input in c++ programming language at run time:</h2>
      <p className="mt-4 para">The ( cin &#62;&#62; ) function is commonly used to input the value.<span className="bold"> cin &#62;&#62;</span> receives them from the keyboard.
</p>
    


      <h2 className='headings'>Q-Write a program to user get only input in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">a; </span>
            <span className="qwerty-10"> &#47;&#47; this declare a variable </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">float </span>
            <span className="qwerty-4">b; </span>
            <span className="qwerty-10"> &#47;&#47; this declare a variable </span>
            {"\n"}{"\n"}
            <span className="qwerty-4">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter </span>
              <span className="qwerty-5">integer </span>
              <span className="qwerty-10">value of a </span>
         
            <span className="qwerty-4">\n </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> a </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-4">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter </span>
              <span className="qwerty-7">float</span>
              <span className="qwerty-10"> value of </span>
            <span className="qwerty-4">b </span>
            <span className="qwerty-4">\n </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-4"> b </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-11"> return </span>
            <span className="qwerty-10">0;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">integer </span>
              <span className="qwerty-10">value of a </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">24 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">float</span>
              <span className="qwerty-10"> value of b </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">6.8 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

      <h3 className="mt-4 mh2">Input in c++ Examples:</h3>

     

      <h2 className='headings'>Q-Write a program to user input in a c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">a,b,c, </span>
            <span className="qwerty-7">sum; </span>
            <span className="qwerty-10"> &#47;&#47; This declare a variable </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-4"> first </span>
            <span className="qwerty-10">no </span>
            <span className="qwerty-3">"; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> a </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter </span>
            <span className="qwerty-4">second</span>
            <span className="qwerty-10"> no </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> b </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter </span>
              <span className="qwerty-4">third </span>
              <span className="qwerty-10">no</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-4"> c </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-7">sum </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">a </span>
              <span className="qwerty-3">+ </span>
              <span className="qwerty-10">b </span>
              <span className="qwerty-3">+ </span>
              <span className="qwerty-10">c </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-7"> sum</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-11">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">first </span>
              <span className="qwerty-10">no </span>
              <span className="qwerty-5">24 </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">second </span>
              <span className="qwerty-10">no </span>
              <span className="qwerty-5">14 </span>
              {"\n"}{"\n"}{" "}  
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">third </span>
              <span className="qwerty-10">no </span>
              <span className="qwerty-5">25 </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">sum </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">63 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

   

      <h2 className='headings'>Q-Write a program to calculate and print simple interest in c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">float </span>
            <span className="qwerty-4">p,r,t,si; </span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-4"> the value of </span>
            <span className="qwerty-10">p </span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> p </span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-4"> the value of </span>
            <span className="qwerty-10">r </span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> r </span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter</span>
            <span className="qwerty-4"> the value of </span>
            <span className="qwerty-10">t </span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> t </span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">si </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">p</span>
              <span className="qwerty-3">* </span>
              <span className="qwerty-10">r</span>
              <span className="qwerty-3">* </span>
              <span className="qwerty-10">t</span>
              <span className="qwerty-3">/ </span>
              <span className="qwerty-10">100 </span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-7">si</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-11">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">the value of p </span>
              <span className="qwerty-10">45 </span>
              {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">the value of r </span>
              <span className="qwerty-10">68 </span>
              {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">the value of t </span>
              <span className="qwerty-10">25 </span>
              {"\n"} {"\n"}
              <span className="qwerty-10">si </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">765</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>




      <h2 className='headings'>Q-Write a program to find and print the area of the rectangle in a c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-4">l,b,area; </span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">l</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> l </span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}   
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">b</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4"> b</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-7">area </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-11">l</span>
            <span className="qwerty-3">* </span>
            <span className="qwerty-11">b</span>
            <span className="qwerty-3">;</span>
            {"\n"} 
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">area</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of l </span>
              <span className="qwerty-10">4 </span>
              {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of b </span>
              <span className="qwerty-10">5 </span>
              {"\n"} {"\n"}
              <span className="qwerty-10">area </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">20</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>

 
      <h2 className='headings'>Q-Write a program to find out the value of pi and print area of the circle in a c++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">float</span>
            <span className="qwerty-4"> r,area; </span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">r</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">r</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}   
            <span className="qwerty-7">area </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">3.14 </span>
            <span className="qwerty-3">* </span>
            <span className="qwerty-11">r</span>
            <span className="qwerty-3">* </span>
            <span className="qwerty-11">r</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">area</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of r </span>
              <span className="qwerty-10">2 </span>
              {"\n"} {"\n"}
              <span className="qwerty-10">area </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">12.56</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


 

      <h2 className='headings'>Q-Write a program to 3 subject marks add all values, and multiply all the values in the C++ programming language example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-11">int</span>
            <span className="qwerty-4"> a,b,c,add,mult; </span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">a</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">b</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">enter a value of </span>
            <span className="qwerty-11">c</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}
            <span className="qwerty-10">add </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">a </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-4">b </span>
            <span className="qwerty-3">+ </span>
            <span className="qwerty-4">c </span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-7">mult </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3">*</span>
            <span className="qwerty-4">b </span>
            <span className="qwerty-4">*</span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-3">;</span>
            {"\n"} {"\n"}   
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">add </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">\n</span>
            <span className="qwerty-3">"; </span>
            {"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-7">mult</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of a </span>
              <span className="qwerty-10">2 </span>
              {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of b </span>
              <span className="qwerty-10">4 </span>
              {"\n"} 
              <span className="qwerty-10">enter </span>
              <span className="qwerty-5">a value of c </span>
              <span className="qwerty-10">6 </span>
              {"\n"} {"\n"}
              <span className="qwerty-10">total </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">12</span>
              {"\n"} 
              <span className="qwerty-10">multiply </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-5">48</span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/cpp-first-program"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-literal"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
  )

}
export default Cinput;